import { Skeleton, Timeline } from 'antd'

export const TimelineSkeleton = () => {
  return (
    <Timeline
      mode='left'
      items={Array.from({ length: 3 }).map(() => ({
        label: (
          <Skeleton
            title={false}
            paragraph={{
              rows: 2,
              width: ['80%', '60%'],
              style: { // Se establece el estilo para que el Skeleton se alinee a la derecha
                display: 'flex',
                justifyContent: 'end',
                flexWrap: 'wrap'
              },
            }}
          />
        ),
        children: (
          <Skeleton
            title={false}
            paragraph={{ rows: 1, width: ['80%'] }}
          />
        ),
        style: { minHeight: '4em' },
      }))}
    />
  );
};